export const environment = {
        production: false,
        salaryCalcServiceUrl: 'api/'
};